<template>
  <div class="slide jackpot-slide stadium-jackpot-slide">
    <p>
      {{ $t("hit_total_odds_slider") }}
      <span class="odds">{{ totalOdds }}</span> {{ $t("hit_total_odds_slider_2") }}
    </p>
    <div class="a-vs-b-jackpot">
      <img src="https://cloud.aleacontrol.com/media/vSoccer/stadium.svg" alt="stadium" />
      <div class="a-vs-b-jackpot-body">
        <span class="jackpot-title">{{ $t("stadium_jackpot") }}</span>
        <p>
          <span class="amount">{{ format(amount) }}</span>
          <span class="currency">&nbsp;{{ currency.toUpperCase() }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    amount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    totalOdds: {
      type: String,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers())
    }
  }
}

</script>
